(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-redek"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    const filters = document.querySelectorAll('#filters label');
    filters.forEach((filter) => {
      const select = filter.querySelector('select');
      const filter_id = select.getAttribute('id');
      const label = filter.querySelector('.label');

      if (select) {
        const selectedOption = select.options[select.selectedIndex];
        label.textContent = selectedOption.textContent;
      }

      select.addEventListener('change', function () {
        const selectedOption = this.options[this.selectedIndex];
        label.textContent = selectedOption.textContent;

        const url = new URL(window.location.href);
        const value = this.value;

        if (value === 'all') {
          url.searchParams.delete(filter_id);
        } else {
          url.searchParams.set(filter_id, value);
        }

        window.location.href = url.toString();
      });
    });

    const filterBtn = document.getElementById('filter-btn');
    const filterPanel = document.getElementById('filter-panel');
    filterBtn.addEventListener('click', function () {
      filterBtn.classList.add('filter-active');
      filterPanel.classList.add('filter-active');
    });

    const filterClose = document.getElementById('filter-close');
    filterClose.addEventListener('click', function () {
      filterBtn.classList.remove('filter-active');
      filterPanel.classList.remove('filter-active');
    });

    let selectedFilters = [];
    const filterValues = document.querySelectorAll('.filter-value');
    filterValues.forEach((filterValue) => {
      if (filterValue.classList.contains('active')) {
        selectedFilters.push({
          param: filterValue.getAttribute('data-filter-param'),
          value: filterValue.getAttribute('data-filter-value'),
        });
      }
      filterValue.addEventListener('click', function () {
        const param = this.getAttribute('data-filter-param');
        const value = this.getAttribute('data-filter-value');
        if (selectedFilters.find((f) => f.param === param && f.value === value)) {
          filterValue.classList.remove('active');
          selectedFilters = selectedFilters.filter((f) => !(f.param === param && f.value === value));
        } else {
          filterValue.classList.add('active');
          selectedFilters.push({ param, value });
        }
        updatePreview();
      });
    });

    const filterStart = document.getElementById('filter-start');
    filterStart.addEventListener('click', function () {
      if (selectedFilters.length > 0) {
        const collectionUrl = this.getAttribute('data-collection-url');
        const url = new URL(collectionUrl, window.location.origin);
        selectedFilters.forEach((filter) => {
          if (filter.value) {
            url.searchParams.append(filter.param, filter.value);
          }
        });
        window.location.href = url.toString();
      }
    });

    const rangeMin = document.getElementById('range-min');
    const rangeMax = document.getElementById('range-max');
    const filterRangeMax = document.getElementById('range-max').getAttribute('max');
    rangeMin.addEventListener('input', updateFill);
    rangeMax.addEventListener('input', updateFill);
    rangeMin.addEventListener('pointerup', updateRange);
    rangeMax.addEventListener('pointerup', updateRange);

    function updateFill(el) {
      let min = parseInt(document.getElementById('range-min').value);
      let max = parseInt(document.getElementById('range-max').value);
      if (min > max) [min, max] = [max, min];
      const percentMin = (min / filterRangeMax) * 100;
      const percentMax = (max / filterRangeMax) * 100;
      document.getElementById('range-fill').style.left = percentMin + '%';
      document.getElementById('range-fill').style.width = percentMax - percentMin + '%';
      document.getElementById('range-min-value').textContent = min;
      document.getElementById('range-max-value').textContent = max;
    }
    updateFill();

    function updateRange() {
      const min = document.querySelector('[name="filter.v.price.gte"]').value;
      const max = document.querySelector('[name="filter.v.price.lte"]').value;
      // Remove existing price filters
      selectedFilters = selectedFilters.filter(
        (filter) => filter.param !== 'filter.v.price.gte' && filter.param !== 'filter.v.price.lte'
      );
      selectedFilters.push({
        param: 'filter.v.price.gte',
        value: min,
      });
      selectedFilters.push({
        param: 'filter.v.price.lte',
        value: max,
      });
      updatePreview();
    }

    function updatePreview() {
      const collectionUrl = document.getElementById('filter-start').getAttribute('data-collection-url');
      const url = new URL(collectionUrl, window.location.origin);
      selectedFilters.forEach((filter) => {
        if (filter.value) {
          url.searchParams.append(filter.param, filter.value);
        }
      });
      fetch(url.toString())
        .then((response) => response.text())
        .then((html) => {
          const parser = new DOMParser();
          const doc = parser.parseFromString(html, 'text/html');
          const productsGrid = doc.querySelector('#products-grid');
          if (productsGrid) {
            console.log(productsGrid);
            const count = parseInt(productsGrid.getAttribute('data-count'));
            updateFilterCta(count);
          }
        })
        .catch((error) => {
          console.error('Error fetching collection:', error);
        });
    }

    function updateFilterCta(count) {
      const filterCta = document.getElementById('filter-start');
      filterCta.querySelector('.item-count').innerText = count;
      console.log('Update filter CTA with count:', count);
      if (count > 0) {
        filterCta.removeAttribute('disabled');
      } else {
        filterCta.setAttribute('disabled', true);
      }
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    gsap.fromTo(
      '.filter-elements',
      {
        y: 0,
      },
      {
        y: '200%',
        duration: 0.3,
        ease: 'expo.inOut',
        scrollTrigger: {
          trigger: 'section.main-collection',
          start: `bottom bottom`,
          toggleActions: 'play none none reverse',
        },
      },
    );

    const filters = document.querySelectorAll('#filters label');
    filters.forEach((filter) => {
      const select = filter.querySelector('select');
      const filter_id = select.getAttribute('id');
      const label = filter.querySelector('.label');

      if (select) {
        const selectedOption = select.options[select.selectedIndex];
        label.textContent = selectedOption.textContent;
      }

      select.addEventListener('change', function () {
        const selectedOption = this.options[this.selectedIndex];
        label.textContent = selectedOption.textContent;

        const url = new URL(window.location.href);
        const value = this.value;

        if (value === 'all') {
          url.searchParams.delete(filter_id);
        } else {
          url.searchParams.set(filter_id, value);
        }

        window.location.href = url.toString();
      });
    });

    const filterBtn = document.getElementById('filter-btn');
    const filterPanel = document.getElementById('filter-panel');
    filterBtn.addEventListener('click', function () {
      filterBtn.classList.add('filter-active');
      filterPanel.classList.add('filter-active');
    });

    const filterClose = document.getElementById('filter-close');
    filterClose.addEventListener('click', function () {
      filterBtn.classList.remove('filter-active');
      filterPanel.classList.remove('filter-active');
    });

    let selectedFilters = [];
    const filterValues = document.querySelectorAll('.filter-value');
    filterValues.forEach((filterValue) => {
      if (filterValue.classList.contains('active')) {
        selectedFilters.push({
          param: filterValue.getAttribute('data-filter-param'),
          value: filterValue.getAttribute('data-filter-value'),
        });
      }
      filterValue.addEventListener('click', function () {
        const param = this.getAttribute('data-filter-param');
        const value = this.getAttribute('data-filter-value');
        if (selectedFilters.find((f) => f.param === param && f.value === value)) {
          filterValue.classList.remove('active');
          selectedFilters = selectedFilters.filter((f) => !(f.param === param && f.value === value));
        } else {
          filterValue.classList.add('active');
          selectedFilters.push({ param, value });
        }
        updatePreview();
      });
    });

    const filterStart = document.getElementById('filter-start');
    filterStart.addEventListener('click', function () {
      if (selectedFilters.length > 0) {
        const collectionUrl = this.getAttribute('data-collection-url');
        const url = new URL(collectionUrl, window.location.origin);
        selectedFilters.forEach((filter) => {
          if (filter.value) {
            url.searchParams.append(filter.param, filter.value);
          }
        });
        window.location.href = url.toString();
      }
    });

    const rangeMin = document.getElementById('range-min');
    const rangeMax = document.getElementById('range-max');
    const filterRangeMax = document.getElementById('range-max').getAttribute('max');
    rangeMin.addEventListener('input', updateFill);
    rangeMax.addEventListener('input', updateFill);
    rangeMin.addEventListener('pointerup', updateRange);
    rangeMax.addEventListener('pointerup', updateRange);

    function updateFill(el) {
      let min = parseInt(document.getElementById('range-min').value);
      let max = parseInt(document.getElementById('range-max').value);
      if (min > max) [min, max] = [max, min];
      const percentMin = (min / filterRangeMax) * 100;
      const percentMax = (max / filterRangeMax) * 100;
      document.getElementById('range-fill').style.left = percentMin + '%';
      document.getElementById('range-fill').style.width = percentMax - percentMin + '%';
      document.getElementById('range-min-value').textContent = min;
      document.getElementById('range-max-value').textContent = max;
      if (min != 0) {
        document.getElementById('range-min-value').parentElement.style.color = '#000';
      } else {
        document.getElementById('range-min-value').parentElement.style.color = '';
      }
      if (max != filterRangeMax) {
        document.getElementById('range-max-value').parentElement.style.color = '#000';
      } else {
        document.getElementById('range-max-value').parentElement.style.color = '';
      }
    }
    updateFill();

    function updateRange() {
      const min = document.querySelector('[name="filter.v.price.gte"]').value;
      const max = document.querySelector('[name="filter.v.price.lte"]').value;
      // Remove existing price filters
      selectedFilters = selectedFilters.filter(
        (filter) => filter.param !== 'filter.v.price.gte' && filter.param !== 'filter.v.price.lte',
      );
      selectedFilters.push({
        param: 'filter.v.price.gte',
        value: min,
      });
      selectedFilters.push({
        param: 'filter.v.price.lte',
        value: max,
      });
      updatePreview();
    }

    function updatePreview() {
      console.log('Update preview');
      const collectionUrl = document.getElementById('filter-start').getAttribute('data-collection-url');
      const url = new URL(collectionUrl, window.location.origin);
      selectedFilters.forEach((filter) => {
        if (filter.value) {
          url.searchParams.append(filter.param, filter.value);
        }
      });
      console.log('Fetching collection:', url.toString());
      fetch(url.toString())
        .then((response) => response.text())
        .then((html) => {
          const parser = new DOMParser();
          const doc = parser.parseFromString(html, 'text/html');
          const productsGrid = doc.querySelector('#products-grid');
          if (productsGrid) {
            console.log(productsGrid);
            const count = parseInt(productsGrid.getAttribute('data-count'));
            updateFilterCta(count);
          }
        })
        .catch((error) => {
          console.error('Error fetching collection:', error);
        });
    }

    function updateFilterCta(count) {
      const filterCta = document.getElementById('filter-start');
      filterCta.querySelector('.item-count').innerText = count;
      console.log('Update filter CTA with count:', count);
      if (count > 0) {
        filterCta.removeAttribute('disabled');
      } else {
        filterCta.setAttribute('disabled', true);
      }
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-bundle"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    var elms = document.querySelectorAll('section.product .splide-gallery');
    for (var i = 0; i < elms.length; i++) {
      if (window.matchMedia('(min-width: 768px)').matches) {
        const splide = new Splide(elms[i], {
          trimSpace: false,
          pauseOnHover: false,
          pagination: false,
          flickMaxPages: 1,
          flickPower: 30,
          type: 'loop',
          perPage: 1,
          mediaQuery: 'min',
          gap: 5,
          drag: 'free',
          clones: 2,
          autoWidth: true,
          autoScroll: {
            speed: 1,
            autoStart: true,
            pauseOnHover: false,
          },
        }).mount(window.splide.Extensions);
      } else {
        const splide = new Splide(elms[i], {
          trimSpace: false,
          pauseOnHover: false,
          flickMaxPages: 1,
          flickPower: 30,
          pagination: false,
          type: 'loop',
          perPage: 1,
          mediaQuery: 'min',
        }).mount();
      }
    }

    var elms = document.querySelectorAll('section.product .splide-related');
    for (var i = 0; i < elms.length; i++) {
      const splide = new Splide(elms[i], {
        trimSpace: false,
        pauseOnHover: false,
        pagination: false,
        type: 'loop',
        flickMaxPages: 1,
        flickPower: 30,
        gap: 13,
        perPage: 2,
        perMove: 1,
      }).mount();
    }

    const form = document.getElementById('product-variant-panel');
    if (!form) return;
    const priceElement = form.querySelector('.product-variant-price');
    const optionInputs = form.querySelectorAll('input[type="radio"]');

    let variants = form.getAttribute('data-variant') ? JSON.parse(form.getAttribute('data-variant')) : [];
    let currentVariant = null;

    // Function to update the displayed price
    function updatePrice() {
      console.log('Updating price for current variant:', currentVariant);
      if (currentVariant && currentVariant.available) {
        const priceInCents = currentVariant.price;
        const moneyFormat = form.getAttribute('data-money-format');
        const formattedPrice = Shopify.formatMoney(priceInCents, moneyFormat);
        priceElement.innerHTML = formattedPrice;
      } else {
        priceElement.innerHTML = '';
      }
    }

    // Function to find the matching variant based on selected options
    function findVariant(selectedOptions) {
      return variants.find((variant) => {
        return variant.options.every((option, index) => option === selectedOptions[index]);
      });
    }

    // Get the initial selected options and update price
    function getSelectedOptions() {
      const selectedOptions = [];

      // Group inputs by option position
      const optionsByPosition = {};
      optionInputs.forEach((input) => {
        if (input.checked) {
          const position = parseInt(input.dataset.optionPosition);
          optionsByPosition[position] = input.value;
        }
      });

      // Sort by position and collect values
      Object.keys(optionsByPosition)
        .sort((a, b) => a - b)
        .forEach((position) => {
          selectedOptions.push(optionsByPosition[position]);
        });

      return selectedOptions;
    }

    // Initialize and set up event listeners
    function init() {
      const selectedOptions = getSelectedOptions();
      currentVariant = findVariant(selectedOptions);
      updatePrice();
      updateId(currentVariant);

      optionInputs.forEach((input) => {
        input.addEventListener('change', () => {
          const selectedOptions = getSelectedOptions();
          currentVariant = findVariant(selectedOptions);
          updatePrice();
          updateId(currentVariant);
        });
      });
    }

    function updateId(currentVariant) {
      const variantId = currentVariant ? currentVariant.id : null;
      const idInput = form.querySelector('input[name="id"]');
      idInput.value = variantId || '';
    }

    init();

    gsap.fromTo(
      '.product-sticky-card',
      {
        y: '100%',
      },
      {
        y: 0,
        duration: 0.3,
        ease: 'expo.inOut',
        scrollTrigger: {
          trigger: 'div.main-product-bundle',
          start: `top+=${window.innerHeight / 2}px top`,
          end: 'bottom bottom',
          toggleActions: 'play reverse play reverse',
        },
      }
    );
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-carte-cadeau"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    var elms = document.querySelectorAll('section.product .splide');
    for (var i = 0; i < elms.length; i++) {
      if (window.matchMedia('(min-width: 768px)').matches) {
        const splide = new Splide(elms[i], {
          trimSpace: false,
          pauseOnHover: false,
          pagination: false,
          flickMaxPages: 1,
          flickPower: 30,
          type: 'loop',
          perPage: 1,
          mediaQuery: 'min',
          gap: 5,
          drag: 'free',
          autoWidth: true,
          clones: 2,
          autoScroll: {
            speed: 1,
            autoStart: true,
            pauseOnHover: false,
          },
        }).mount(window.splide.Extensions);
      } else {
        const splide = new Splide(elms[i], {
          trimSpace: false,
          pauseOnHover: false,
          flickMaxPages: 1,
          flickPower: 30,
          pagination: false,
          type: 'loop',
          perPage: 1,
          mediaQuery: 'min',
        }).mount();
      }
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    var elms = document.querySelectorAll('section.product .splide-gallery');
    for (var i = 0; i < elms.length; i++) {
      if (window.matchMedia('(min-width: 768px)').matches) {
        const splide = new Splide(elms[i], {
          trimSpace: false,
          pauseOnHover: false,
          pagination: false,
          type: 'loop',
          perPage: 1,
          mediaQuery: 'min',
          flickMaxPages: 1,
          flickPower: 30,
          gap: 5,
          drag: 'free',
          clones: 2,
          autoWidth: true,
          autoScroll: {
            speed: 1,
            autoStart: true,
            pauseOnHover: false,
          },
        }).mount(window.splide.Extensions);
      } else {
        const splide = new Splide(elms[i], {
          trimSpace: false,
          pauseOnHover: false,
          pagination: false,
          flickMaxPages: 1,
          flickPower: 30,
          type: 'loop',
          perPage: 1,
          mediaQuery: 'min',
        }).mount();
      }
    }

    var elms = document.querySelectorAll('section.product .splide-related');
    for (var i = 0; i < elms.length; i++) {
      const splide = new Splide(elms[i], {
        trimSpace: false,
        pauseOnHover: false,
        pagination: false,
        type: 'loop',
        flickMaxPages: 1,
        flickPower: 30,
        gap: 13,
        perPage: 2,
        perMove: 1,
      }).mount();
    }

    const form = document.getElementById('product-variant-panel');
    if (!form) return;
    const priceElement = form.querySelector('.product-variant-price');
    const optionInputs = form.querySelectorAll('input[type="radio"]');

    let variants = form.getAttribute('data-variant') ? JSON.parse(form.getAttribute('data-variant')) : [];
    let currentVariant = null;
    let updateCheck = 0;

    // Function to update the displayed price
    function updatePrice() {
      if (!priceElement) return;
      console.log('Updating price for current variant:', currentVariant);
      if (currentVariant && currentVariant.available) {
        document.querySelector('.if-available').style.display = 'grid';
        document.querySelector('.if-not-available').style.display = 'none';
        const priceInCents = currentVariant.price;
        const moneyFormat = form.getAttribute('data-money-format');
        const formattedPrice = Shopify.formatMoney(priceInCents, moneyFormat);
        priceElement.innerHTML = formattedPrice;
      } else {
        priceElement.innerHTML = '';
        document.querySelector('.if-available').style.display = 'none';
        document.querySelector('.if-not-available').style.display = 'block';
        updateCheck = 0;
        updateBis();
      }
    }

    function updateBis() {
      setTimeout(() => {
        updateCheck++;
        if (updateCheck > 5) return;
        const bisButton = document.querySelector('#klaviyo-bis-button-container button');
        if (!bisButton) {
          updateBis();
          return;
        }

        bisButton.addEventListener('click', function () {
          document.querySelector('#product-variant-panel').hidePopover();
        });
      }, 100);
    }

    // Function to find the matching variant based on selected options
    function findVariant(selectedOptions) {
      return variants.find((variant) => {
        return variant.options.every((option, index) => option === selectedOptions[index]);
      });
    }

    // Get the initial selected options and update price
    function getSelectedOptions() {
      const selectedOptions = [];

      // Group inputs by option position
      const optionsByPosition = {};
      optionInputs.forEach((input) => {
        if (input.checked) {
          const position = parseInt(input.dataset.optionPosition);
          optionsByPosition[position] = input.value;
        }
      });

      // Sort by position and collect values
      Object.keys(optionsByPosition)
        .sort((a, b) => a - b)
        .forEach((position) => {
          selectedOptions.push(optionsByPosition[position]);
        });

      return selectedOptions;
    }

    // Initialize and set up event listeners
    function init() {
      const selectedOptions = getSelectedOptions();
      currentVariant = findVariant(selectedOptions);
      updatePrice();
      updateId(currentVariant);

      optionInputs.forEach((input) => {
        input.addEventListener('change', () => {
          const selectedOptions = getSelectedOptions();
          currentVariant = findVariant(selectedOptions);
          updatePrice();
          updateId(currentVariant);
        });
      });
    }

    function updateId(currentVariant) {
      const variantId = currentVariant ? currentVariant.id : null;
      const idInput = form.querySelector('input[name="id"]');
      idInput.value = variantId || '';
    }

    init();

    gsap.fromTo(
      '.product-sticky-card',
      {
        y: '100%',
      },
      {
        y: 0,
        duration: 0.3,
        ease: 'expo.inOut',
        scrollTrigger: {
          trigger: 'div.main-product',
          start: `top+=${window.innerHeight / 2}px top`,
          end: 'bottom bottom',
          toggleActions: 'play reverse play reverse',
        },
      }
    );
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["search"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    const filters = document.querySelectorAll('#filters label');
    filters.forEach((filter) => {
      const select = filter.querySelector('select');
      const filter_id = select.getAttribute('id');
      const label = filter.querySelector('.label');

      if (select) {
        const selectedOption = select.options[select.selectedIndex];
        label.textContent = selectedOption.textContent;
      }

      select.addEventListener('change', function () {
        const selectedOption = this.options[this.selectedIndex];
        label.textContent = selectedOption.textContent;

        const url = new URL(window.location.href);
        const value = this.value;

        if (value === 'all') {
          url.searchParams.delete(filter_id);
        } else {
          url.searchParams.set(filter_id, value);
        }

        window.location.href = url.toString();
      });
    });
  });

  } catch(e) { console.error(e); }
})();
})();
